
class CddConfigCtrl {
  tableFkeys = [];
  matchSchema = null;
  tableFkey = null;
  matchFkey = null;
  refName = '';
  loading = 'Loading...'; 
  cddActive = false;
  fkeySchemaReq = null;
  cdd = {
    cddMatchFid: null,
    relatedTokenId: null,
  };
  constructor(TemplateService, SchemaService, FlashService) {
    'ngInject';
    this.ts = TemplateService;
    this.ss = SchemaService;
    this.flash = FlashService;
  }

  $onInit() {
    this.cddActive = this.hasCddData(this.token.options?.cdd);
    this.initialize();
  }
  
  async initialize() {
    if (!this.cddActive) return this.clearCdd();

    this.otherTokens = this.td.template.tokens.filter(t => t.id !== this.token.id);
    const { name, "tableSchema": {foreignKeys} } = this.ts.tokenRef(this.token);
    this.refName = name;
    this.tableFkeys = this.availableFkeys(foreignKeys);
    const tokenFkey = this.tokenFkey(this.token);
    this.matchSchema = await this.ss.getSchema(this.td.template, tokenFkey.tableId);
    this.validateApply(this.token.options?.cdd || {});
    this.loading = false;
  }
  
  clearCdd() {
    delete this.token.options?.cdd;
    this.tableFkey = null;
    this.matchFkey = null;
  }
  
  hasCddData(cdd) {
    return !!Object.values(cdd || {}).filter(v => v).length;
  }
  
  availableFkeys(fKeys) {
    return fKeys.reduce((acc, fk) => {
      const tkn = this.otherTokens.find(t => this.tokenHasFkey(t, fk));
      return tkn ? [...acc, {...fk, relatedTokenId: tkn.id}]  : acc;
    }, []);
  }
  
  tokenHasFkey(t, fk) {
    const tokenFkey = this.tokenFkey(t);
    return fk.tableId === tokenFkey?.tableId && fk.fieldId === tokenFkey?.fieldId;
  }
  
  tokenFkey(token) {
    const { "tableSchema": {foreignKeys} } = this.ts.tokenRef(token);
    return foreignKeys.find(fk => fk.fieldId === token.fieldId);
  }
  
  onChange() {
    if (!this.tableFkey) this.matchFkey = null;
    
    this.cdd.relatedTokenId = this.tableFkey?.relatedTokenId || null;
    this.cdd.cddMatchFid = this.matchFkey?.fieldId || null;
    
    this.validateApply(this.cdd || {});
  }
  
  fkName(name, fKey) {
    return `${name}: ${fKey.label}`;
  }
  
  isValidMatchField(tableFkey, item) {
    return this.cddIsValid({
      relatedTokenId: tableFkey?.relatedTokenId,
      cddMatchFid: item.fieldId
    });
  }

  cddComplete({...cdd}) {
    return cdd.cddMatchFid && cdd.relatedTokenId;
  }
  
  cddIsValid(cdd) {
    const {relatedTokenId, cddMatchFid} = cdd;
    const relatedToken = this.ts.tokens.find(t => t.id === relatedTokenId);
    const matchField = this.matchSchema.fields.find(f => f.id === cddMatchFid);

    // if (!relatedToken) throw new Error('CDD Match Token missing!');
    // if (!matchField) throw new Error('Provider CDD Match Field missing!');
    return relatedToken && matchField;
  }
  
  validateApply({...cdd}) {
    if (!this.cddComplete(cdd)) return;
    
    const tableFkey = this.tableFkeys.find(fk => fk.relatedTokenId === cdd.relatedTokenId);
    const matchFkey = this.matchSchema.foreignKeys.find(fk => fk.fieldId === cdd.cddMatchFid);
    
    if (tableFkey && matchFkey && this.cddIsValid(cdd)) {
      Object.assign(this, {tableFkey, matchFkey, cdd});
      this.token.options = {...this.token.options, cdd};
    } else {
      this.flash.error('invalid conditional data, resetting');
      this.clearCdd();
      this.initialize();
    }
    
    this.loading = false;
    
  }
}

export default {
  bindings: {
    token: "=",
    td: '<'
  },
  templateUrl: "form-builder/forms/cdd-config/cdd-config.component.html",
  controller: CddConfigCtrl
};